import GenericController from './../generic.controller'
import crowDefaultImage from './../../../../images/crowDefaultImage.png';

export default class Controller extends GenericController {

    constructor(...args) {

        super(...args);

        this.pictures = [];
        this.busy = false;
        this.takePictureInProgress = false;
        this.currentPics = 1;
        this.recordsTotal = 0;

        this.all = true;
        this.zone = null;
        this.takenPicUrl = null;
        this.goingToDeletePicture = null;

        this.initZonesAndPictures();
        this.loading = true;
        this.regiterToCloseEvent();

        this.$element.on('$destroy', () => {
            this.closeModal('takePicModal');
        });

        this.$scope.crowDefaultImage = crowDefaultImage;
        this.$scope.imgError = (source) => {
            source.src = this.$scope.crowDefaultImage;
        };

        this.$scope.camTypeFilter = function (item) {
            return item.type == 55 || item.type == 83 || item.type == 85;
        };
    }

    initZonesAndPictures() {

        if (this.$rootScope.isConnected == true) {

            this.getZonesConfigList()
                .then(resp => {

                    this.zones = resp;
                    this.loading = false;
                    this.selectZone();
                })
                .catch(() => {
                    this.loading = false;
                });
        }

        else {
            this.selectZone();
        }
    }

    deletePicture(pictureId) {

        let index = this.pictures.findIndex(v => v.id === pictureId);

        this._PanelsService.deletePicture(this.panelId, pictureId)
            .then(() => {
                this.pictures.splice(index, index + 1);
                this.takenPicUrl = null;
            });
    }

    selectZone(zone) {

        if (zone) {
            this.zone = zone;
            this.currentZoneId = zone.id;
            this.all = false;
        }
        else {
            this.zone = this.currentZoneId = null;
            this.all = true;
        }
        this.reset();
    }

    checkZone() {

        return (item) => {
            // not item - bug
            if (!item) return false;

            // no item provided is 'all'
            if (!this.zone) return true;

            return (this.zone.id + 1) === item.zone;

        };

    }

    getAllPictures(reload) {

        this.busy = true;

        this._PanelsService.getPictures(this.panelId, this.currentPics)
            .then(resp => {

                this.nextPage = resp.data.next;
                let newPics = resp.data.results;
                this.recordsTotal = resp.data.recordsTotal;
                this.busy = false;
                this.loading = false;

                if (reload) {
                    this.pictures = newPics;
                }
                else {
                    this.pictures.push(...newPics);
                }
                this.currentPics += 1;
            })
            .catch(() => {
                this.getPicFail();
                this.loading = false;
            });

    }

    preventTakePicModalClose() {

        $('#takePicModal').on('hide.bs.modal.prevent', (e) => {
            e.preventDefault();
        })

    }

    confirmTakePicModalClose() {

        $('#takePicModal').off('hide.bs.modal.prevent')

    }

    regiterToCloseEvent() {

        $('#takePicModal').on('hidden.bs.modal', () => {
            this.selectZone(this.zone);
        });

    }

    takePicture() {

        this.takePictureBusy = true;
        this.preventTakePicModalClose();
        this.resetTakePic();
        this._PanelsService.takePicture(this.panelId, this.currentZoneId).then(resp => {

            this.takenPicUrl = resp.data.url;
            this.lastTakenPic = resp.data;
            this.confirmTakePicModalClose();
            this.takePictureBusy = false;

        })
            .catch(() => {

                this.failToTakePicture = true;
                this.confirmTakePicModalClose();
                this.takePictureBusy = false;

            });
        this.showModal('takePicModal');
    }

    cancelTakePicture() {
        this._PanelsService.cancelTakePicture(this.panelId, this.currentZoneId).catch(() => {
        });
        this.confirmTakePicModalClose();
    }

    resetTakePic() {
        this.takenPicUrl = null;
        this.failToTakePicture = false;
    }

    setGoingToDeletePicture(picture) {
        this.goingToDeletePicture = picture;
        this.showModal('deletePicModal');
    }

    getZonePictures(reload) {

        this.busy = true;

        this._PanelsService.getZonePictures(this.panelId, this.currentZoneId, this.currentPics).then(r => {

            this.nextPage = r.data.next;
            let newPics = r.data.results;
            this.recordsTotal = r.data.recordsTotal;
            this.busy = false;

            if (reload) {
                this.pictures = newPics;
            }
            else {
                this.pictures.push(...newPics);
            }

            this.currentPics += 1;
        })

            .catch(() => {
                this.getPicFail();
            });
    }

    getPicFail() {
        this.busy = false;
        this.nextPage = null;
    }

    reset() {
        this.nextPage = 1;
        this.currentPics = 1;
        this.pictures = [];
        this.getPictures();
    }

    getPictures() {

        if (this.nextPage != null && !this.busy) {

            if (this.all == true) {
                this.getAllPictures();
            }
            else {
                this.getZonePictures();
            }
        }
    }

}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/pictures.component/controller.js
 **/